import React, { FC } from "react";
import { useImmer } from "use-immer";

import {
  IgButton,
  IgDivider,
  IgTextField,
  IgTypography,
} from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { useConfiguration } from "../../api/configurations/use-configuration";
import { useMutatePriceScraperConfig } from "../../api/organization-actions/post-price-scraper-submission";
import { useViewPage } from "../../hooks/mixpanel";
import { contactSupport } from "../../utils/contactSupport";

type StoreList = {
  key: any;
  domain: string;
};

export const PriceScraper: FC = () => {
  const [storeList, setStoreList] = useImmer<StoreList[]>([]);
  const priceScraper = useMutatePriceScraperConfig();
  const isPriceScraperSubmitted = useConfiguration(
    "is_price_scraper_submitted"
  );

  const handleUpdate = (index: number, value: string) => {
    const foundIndex = storeList.findIndex((val) => val.key === index);
    if (foundIndex !== -1) {
      setStoreList((draft) => {
        draft[foundIndex].domain = value;
        return draft;
      });
    } else {
      setStoreList((draft) => {
        draft = [...draft, { key: index, domain: value }];
        return draft;
      });
    }
  };

  const onSubmit = () => {
    priceScraper.mutate(storeList.map((val) => val.domain));
  };

  useViewPage("Price AI");

  return (
    <Grid container direction={"column"} rowSpacing={1}>
      <Grid item>
        <IgTypography igStyle={"title"}>Intelligems Price Scraper</IgTypography>
      </Grid>
      <IgDivider spacing={"s"} />
      {isPriceScraperSubmitted?.value ? (
        <IgTypography variant={"body1"}>
          Thank you for your submission! We will email you in the next 24 hours
          with your price tracking information. To submit new product urls,
          please contact us{" "}
          <IgButton
            sx={{ fontSize: "16px", marginTop: "-3.5px", marginLeft: "-14px" }}
            onClick={() => {
              contactSupport();
            }}
          >
            here.
          </IgButton>
        </IgTypography>
      ) : (
        <>
          <Grid item>
            <IgTypography>
              Use the price scraper to track product price changes for up to 5
              stores! Example: https://mycompetitor.com/products/cool-widget
            </IgTypography>
          </Grid>
          <Grid
            container
            item
            rowSpacing={2}
            direction={"column"}
            sx={{ marginTop: "1px", marginBottom: "15px", pb: "8px" }}
          >
            {[0, 1, 2, 3, 4].map((val, index) => (
              <Grid item key={index}>
                <IgTextField
                  sx={{ backgroundColor: "white" }}
                  onChange={(e) => {
                    handleUpdate(index, e.target.value);
                  }}
                  fullWidth={true}
                  label={`Site #${index + 1} URL`}
                  variant={"outlined"}
                />
              </Grid>
            ))}
          </Grid>
          <Grid item>
            <IgButton
              disabled={storeList.length < 1}
              loading={priceScraper.isPending}
              onClick={onSubmit}
              variant={"contained"}
            >
              Submit
            </IgButton>
          </Grid>
        </>
      )}
    </Grid>
  );
};
